import React from "react";

import icon from "../../../assets/images/staffi-business-lines.png";

const StaffiBusinessLines = ({ ...props }) => {
  return <img src={icon} {...props}></img>
};

export default StaffiBusinessLines;
